import { Loader } from "components/loader"
import { useEffect } from "react";

export const FullScreenLoading = () => {
  useEffect(() => {
    const preventAll = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    document.addEventListener('click', preventAll, true);
    document.addEventListener('mousedown', preventAll, true);
    document.addEventListener('mouseup', preventAll, true);
    document.addEventListener('touchstart', preventAll, true);
    document.addEventListener('touchend', preventAll, true);
    document.addEventListener('keydown', preventAll, true);
    
    document.body.style.pointerEvents = 'none';
    
    // Clean up when component unmount
    return () => {
      document.removeEventListener('click', preventAll, true);
      document.removeEventListener('mousedown', preventAll, true);
      document.removeEventListener('mouseup', preventAll, true);
      document.removeEventListener('touchstart', preventAll, true);
      document.removeEventListener('touchend', preventAll, true);
      document.removeEventListener('keydown', preventAll, true);
      
      document.body.style.pointerEvents = 'auto';
    };
  }, []);

  return (
    <div className="fixed inset-0 top-[-1px] bg-gray-900/50 z-[100] flex items-center justify-center">
      <Loader fillColors={["#011BB6", "#F1600D", "#ffffff"]} />    
    </div>
  );
};